import React from 'react'
import ClosureSurvey from 'sprockets_react/closure_survey/registry'

ClosureSurvey.Form = function({stepComponent}) {
  return(
    <form id="closure_survey_form">
        { stepComponent }
    </form>
  )
}
